// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__1zPMY","header":"style_header__3ghkE","warningLink":"style_warningLink__h-k3q","searchBar":"style_searchBar__BJFzd","main":"style_main__1fc_L"};